'use strict';

var $ = global.jQuery;


$('body').on('click', '.accordion-holder', function() {
	$(this).toggleClass('active');
});